<template>
  <v-sheet
    id="atas"
    class="hero pa-6 mb-4"
    elevation="0">
    <v-row
      align="start"
      class="hero-grid">
      <v-col
        cols="12"
        md="7">
        <div class="eyebrow">Portal Kabupaten Klaten</div>
        <div class="hero-title text-h4 font-weight-bold mb-0">
          Infografis Terpadu SIMPELBANG &amp; JDIH
        </div>
        <p class="hero-lead text-body-2 mt-3 mb-0">
          Rancangan tampilan dashboard yang lebih modern, rapi, dan mudah dibaca.
          Data dipisahkan dalam 2 tab utama agar fokus informasi lebih jelas.
        </p>
      </v-col>

      <v-col
        cols="12"
        md="5">
        <v-card
          outlined
          class="hero-panel pa-4">
          <h3 class="text-subtitle-1 font-weight-bold mb-3 white--text">
            Ringkasan Tampilan
          </h3>
          <v-row dense>
            <v-col
              v-for="stat in heroStats"
              :key="stat.label"
              cols="6">
              <div class="hero-stat">
                <div class="label">{{ stat.label }}</div>
                <div class="value">{{ stat.value }}</div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      heroStats: [
        { label: 'Modul Utama', value: 'SIMPELBANG + JDIH' },
        { label: 'Sumber Data', value: 'API Real-time' },
        { label: 'Periode', value: '12 Bulan' },
        { label: 'Tampilan', value: 'Desktop & Mobile' }
      ]
    }
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  border-radius: 28px;
  overflow: hidden;
  background: linear-gradient(135deg, #143b89 0%, #1b5fc1 50%, #1197d9 100%);
  box-shadow: 0 18px 42px rgba(17, 64, 122, 0.22);
}

.hero::before,
.hero::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  pointer-events: none;
}

.hero::before {
  width: 240px;
  height: 240px;
  right: -70px;
  top: -80px;
}

.hero::after {
  width: 180px;
  height: 180px;
  right: 120px;
  bottom: -90px;
}

.hero-grid {
  position: relative;
  z-index: 1;
}

.eyebrow {
  color: rgba(255, 255, 255, 0.88);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: 700;
}

.hero-title {
  color: #ffffff;
  line-height: 1.15;
}

.hero-lead {
  color: rgba(255, 255, 255, 0.92);
  max-width: 760px;
  line-height: 1.5;
}

.hero-panel {
  border-radius: 22px !important;
  background: rgba(255, 255, 255, 0.12) !important;
  border-color: rgba(255, 255, 255, 0.16) !important;
  backdrop-filter: blur(8px);
}

.hero-stat {
  background: rgba(255, 255, 255, 0.13);
  border-radius: 16px;
  padding: 12px 14px;
}

.hero-stat .label {
  font-size: 12px;
  opacity: 0.78;
  margin-bottom: 6px;
  color: #ffffff;
}

.hero-stat .value {
  font-size: 17px;
  font-weight: 800;
  color: #ffffff;
}
</style>
